import getLocationRouterSelect from 'modules/router/selectors/get-location'
import { createSelector } from 'reselect'

const getPathnameRouterSelect = createSelector(
  getLocationRouterSelect,
  (location) => location ? location.pathname : ''
)

export default getPathnameRouterSelect
